// Shared, defensive helpers for rendering a criticality tier from ANY form.
// Handles: integer (1 -> "Tier 1"), "tier_N" string ("tier_1" -> "Tier 1"),
// "Tier N" / "N" strings, and null/undefined (neutral placeholder).
// Display-only: does NOT change stored data, scoring, or routing.

function tierNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  const s = String(value).trim().toLowerCase();
  if (!s || s === "none") return null;
  const m = s.match(/(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

// Normalised key for color/label lookups keyed by "tier_N". Returns null when unknown.
export function tierKey(value) {
  const n = tierNumber(value);
  return n ? `tier_${n}` : null;
}

// Human label, e.g. "Tier 1". Returns the placeholder (default "—") when unknown.
export function formatTier(value, placeholder = "—") {
  const n = tierNumber(value);
  return n ? `Tier ${n}` : placeholder;
}
